export default [
  {
    name: 'ContactLinksCompaniesList',
    path: 'settings/companies/contact-links',
    component: () => import('pages/settings/contact-links/ContactLinksCompaniesList.vue')
  },
  {
    name: 'ContactLinksEdit',
    path: 'settings/companies/:id/contact-links/edit',
    component: () => import('pages/settings/contact-links/ContactLinksEdit.vue')
  }
]
